import moment from 'moment';

const clientCommunicationsReducerDefaultState = () => ({
  clientSmsText: {},
  countClients: {},
  clientList: [],
  clientListWithoutTimeRange: [],
  hasFailure: false,
  loadingClientsData: true,
  smsMessage: '',
  numOfMessages: 0,
  messageSent: false,
  errorMessage: '',
  isFetching: false,
  selectedLastVisit: '',
  selectedNextVisit: '',
  selectedStylistIds: [],
  selectedServices: [],
  selectedLoyalty: {
    isAnyAmount: null,
    amount: undefined,
    isAnyNumber: false,
    number: 0,
  },
  isOptChecked: false,
  isHideWithoutPhone: false,
  expected_recipient_count: 0,
  expected_count: 0,
  // optoutMessageCost: 0,
  numClientsToBeSentOptout: 0,
  originalRecipientsCount: 0,
  unique_recipients_count: 0,
  campaignsSent: 0,
  clientsMessaged: 0,
  revenueGenerated: 0,
  bookingsRecieved: 0,
  campaignsSentDirect: 0,
  clientsMessagedDirect: 0,
  revenueGeneratedDirect: 0,
  bookingsRecievedDirect: 0,
  campaignsSentAuto: 0,
  clientsMessagedAuto: 0,
  revenueGeneratedAuto: 0,
  bookingsRecievedAuto: 0,
  campaigns: [],
  blastSms: [],
  autoMessages: [],
  selectedTimeRange: {
    fromDate: moment().weekday(0),
    toDate: moment().weekday(6),
  },
  lastDatesSelected: null,
  deleted_count: 0,
  upcoming_clients: [],
  upcoming_count: 0,
  bulkDeleteSuccess: false,
  bulkOptoutSuccess: false,
  clients_with_notes: null,
  clientsFilteredButNoPhone: [],
  sms_credits_available: 0,
  sending_allowed: false,
  autoSmsByMonth: null,
  blastSmsByMonth: null,
  oneToOneSmsByMonth: null,
  groupOrderChanged: '',
});

export default clientCommunicationsReducerDefaultState;
